import { splitLocale } from '../localeUtils';

/**
 * Convert a locale to the file extension used in @sas/github-localization-repository.
 *
 * @param locale
 * @returns
 */
export const novaLocaleToFileExtension = locale => {
  if (locale === 'en') return '';
  const {
    lang,
    region,
    script
  } = splitLocale(locale);
  let extension = `_${lang}`;
  // zh locales separate language and script with a '-'.
  if (script) extension += `-${script}`;
  // language and region is separated by an '_'
  if (region) extension += `_${region}`;
  return extension;
};
export const unsupportedBundleMessage = (locale, bundle) => `${bundle} for ${locale} is not supported by this backend.`;
export const bundleNotFoundMessage = (locale, bundle) =>
// eslint-disable-next-line @sas/i18n/jsx-to-localize
`Could not find ${bundle} for ${locale}.`;
//# sourceMappingURL=util.js.map